import { render, staticRenderFns } from "./desktopHeader.vue?vue&type=template&id=3e6bb08b&"
import script from "./desktopHeader.vue?vue&type=script&lang=js&"
export * from "./desktopHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports